document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".hc-faq-trigger").forEach(trigger => {
    trigger.addEventListener("click", function () {
      let sectionValue = this.getAttribute("data-section");
      let relatedElements = document.querySelectorAll(`.hc-answer-question[data-section='${sectionValue}']`);

      this.classList.toggle('hc-opened');
      relatedElements.forEach(element => {
        if (element.style.display === "none" || element.style.display === "") {
            element.style.display = "block";
        } else {
            element.style.display = "none";
        }
      });
    });
  });
});

 function scrollToAndClickDataQ() {
  if (!document.querySelector('.hc-template-faq')) return;

  let hash = decodeURIComponent(window.location.hash.substring(1));
  hash = hash.split('?')[0];
  if (!hash) return;

  const target = document.querySelector(`[data-q="${hash}"]`);
  if (target) {
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });

    setTimeout(() => {
      target.click(); 
    }, 800);
  }
}

window.addEventListener('DOMContentLoaded', scrollToAndClickDataQ);
window.addEventListener('hashchange', scrollToAndClickDataQ);